// 今日吃瓜 · 站内内容数据（仅供静态展示与页面渲染）
export const siteMeta = {
  brand: "今日吃瓜",
  slogan: "内幕深扒 · 内幕真相",
  tagline: "把零散线索收拢成完整叙事，只看公开材料整理，帮你形成自己的判断",
  domain: "https://huajuan1107.cn",
  email: "hello@jinrichigua.example.com",
  copyright: "今日吃瓜",
  description:
    "今日吃瓜是专注娱乐行业内幕深扒的资讯站，以时间线复盘的方式梳理圈内热点、内幕消息与内幕真相，结合影视、音乐、综艺与粉丝生态观察，一网看尽不用翻。",
  keywords: "今日吃瓜,今日吃瓜内幕,今日吃瓜深扒,今日吃瓜内幕深扒,今日吃瓜内幕真相,圈内热点,时间线复盘",
};

export interface Channel {
  slug: string;
  name: string;
  label: string;
  tagline: string;
  intro: string;
  tone: "primary" | "accent" | "secondary";
}

export const channels: Channel[] = [
  {
    slug: "hongguan",
    name: "红馆速递",
    label: "热点",
    tagline: "每日圈内热点速递",
    intro: "把热搜里的来龙去脉摊开讲清楚，快、准、不带节奏，一条线索串起一整天的热闹。",
    tone: "primary",
  },
  {
    slug: "shenba",
    name: "深扒档案",
    label: "深扒",
    tagline: "把线索收拢成完整叙事",
    intro: "按公开材料整理内幕消息与内幕真相，串联时间线、交叉关键节点，不做主观猜测，给喜欢深究事件背后的你。",
    tone: "accent",
  },
  {
    slug: "yingshi",
    name: "光影幕后",
    label: "影视",
    tagline: "台前幕后的行业生态",
    intro: "从番位到排片，从服化道到录音棚，聊一聊影视行业的门道与不为人知的运作细节。",
    tone: "secondary",
  },
  {
    slug: "yule",
    name: "娱圈观察",
    label: "观察",
    tagline: "现象背后的运行规则",
    intro: "演唱会经济、粉丝生态、综艺剧本感……把娱乐圈的现象拆开，看它为何如此发生。",
    tone: "secondary",
  },
];

export interface TimelinePoint {
  time: string;
  title: string;
  text: string;
}

export interface ArticleSection {
  heading?: string;
  paragraphs: string[];
}

export interface Article {
  slug: string;
  channel: string;
  kind: "深扒" | "复盘" | "速递" | "观察";
  title: string;
  dek: string;
  excerpt: string;
  author: string;
  date: string;
  minutes: number;
  heat: number;
  tags: string[];
  featured?: boolean;
  hot?: boolean;
  timeline?: TimelinePoint[];
  sections: ArticleSection[];
}

export const articles: Article[] = [
  // ---------- 深扒档案 ----------
  {
    slug: "shenba-xuanxiu-juben",
    channel: "shenba",
    kind: "深扒",
    title: "番位之争幕后：一档选秀综艺“剧本感”争议全程时间线",
    dek: "从选手候场风波到后期剪辑补镜，一档人气选秀的舆情是如何一步步发酵的？",
    excerpt:
      "我们把这档节目从官宣、初舞台、淘汰到总决赛的热搜节点按时间串联，交叉比对通告、路透与官方回应，还原“剧本感”争议的完整脉络。",
    author: "瓜田主笔",
    date: "2026-08-28",
    minutes: 9,
    heat: 98210,
    featured: true,
    tags: ["选秀", "综艺", "剧本感", "时间线"],
    timeline: [
      {
        time: "D-21",
        title: "官宣阵容，番位排序引初议",
        text: "节目组公布导师与嘉宾阵容，海报站位与名单顺序当晚即在各平台引发关于“压番”与“待遇”的讨论，热度过万。",
      },
      {
        time: "D-3",
        title: "初舞台彩排流出，镜头量存疑",
        text: "一段自称“彩排实拍”的视频流传，部分选手镜头时长被逐帧统计对比，剪辑倾向成为焦点。",
      },
      {
        time: "D0",
        title: "首期播出，剧本感集中爆发",
        text: "首期播出后“剧本感”“恶意剪辑”等关键词登上热搜，评论区分化成挺节目与骂剧本两大阵营。",
      },
      {
        time: "D+2",
        title: "节目组首份声明：称还原现场",
        text: "节目组发布声明表示“无刻意设计剧本，镜头取舍基于时长与播出效果”，并呼吁理性追综。",
      },
      {
        time: "D+7",
        title: "完整未删减花絮上线，风向转向",
        text: "官方上线后台花絮与部分完整舞台，不少网友对照后认为“并非剪辑问题”，争议热度随之回落。",
      },
    ],
    sections: [
      {
        heading: "从一张海报开始的舆论",
        paragraphs: [
          "一档选秀综艺的第一波热搜，往往不是来自舞台本身，而是一张公布阵容的官方海报。站位前后、名单排序、名字字号，这些细节在网络语境里会被逐像素解读，成为“被区别对待”的第一份证据。我们以这一事件为样本，梳理一场“剧本感”争议是如何被一步步放大成全民议题的。",
          "需要说明的是，以下所有节点均来自节目官方公告、公开播出画面与可检索的媒体转述，我们只做时间线上的整理与交叉比对，不对“是否有剧本”做主观定性，最终判断请以完整播出内容与多方信源为准。",
        ],
      },
      {
        heading: "剪辑争议为什么总在选秀里引爆",
        paragraphs: [
          "选秀节目的“剧本感”之所以容易引爆，是因为它天然存在两条叙事：一是竞技公平的“实力叙事”，二是综艺效果的“剧情叙事”。当观众预设前者的公平性，又被后者明显牵着走时，落差就会转化为对“剪辑”“剧本”的指责。节目组如何在有限时长里平衡两条叙事，几乎是所有真人秀都绕不开的难题。",
          "从传播学看，这类争议往往呈现“证据滞后”的特征：情绪先行、事实后补。这也是为什么我们在复盘时强调，尽量等节目组回应与完整素材出现后再下判断，避免被单一时段的切片带偏节奏。",
        ],
      },
    ],
  },
  {
    slug: "shenba-daikuan-fengbo",
    channel: "shenba",
    kind: "深扒",
    title: "一次商务代言风波复盘：危机公关的七个关键节点",
    dek: "官宣、舆论发酵、撤物料、道歉、解约……代言翻车后的每一步，其实都有章可循。",
    excerpt:
      "以一场典型的商务代言争议为例，拆解从热搜爆出到品牌切割之间，团队与品牌通常经历的七个关键节点，看危机公关如何在几个小时内改写结局。",
    author: "阿剪",
    date: "2026-08-15",
    minutes: 7,
    heat: 66500,
    featured: true,
    tags: ["商务", "危机公关", "代言"],
    timeline: [
      {
        time: "T0",
        title: "旧料被翻出，关键词登榜",
        text: "一条旧采访/旧言论被重新剪辑传播，负面关键词在数小时内登顶热搜，阅读量快速攀升。",
      },
      {
        time: "T+2h",
        title: "品牌方下架预热物料",
        text: "相关品牌陆续撤下官宣海报与置顶内容，动作之快被视为“准备切割”的信号。",
      },
      {
        time: "T+5h",
        title: "团队发声明：致歉并澄清语境",
        text: "当事人团队发布声明，就引发误解之处致歉，同时补充被截断的原话语境，试图引导理性看待。",
      },
      {
        time: "T+10h",
        title: "品牌方回应：暂停合作调查",
        text: "主代言品牌表示暂停相关合作并启动内部核查，公告措辞成为市场关注的焦点。",
      },
      {
        time: "T+24h",
        title: "二次回应与解约落定",
        text: "完整回应与处理结果陆续公布，合作解除或整改方案落地，热度开始进入自然衰减。",
      },
    ],
    sections: [
      {
        heading: "危机公关的黄金窗口很短",
        paragraphs: [
          "代言人风险一旦引爆，留给各方的缓冲时间往往以小时计算。品牌要在“保住形象”与“避免被连带反噬”之间做权衡，团队则要在“真诚致歉”与“澄清事实”之间拿捏分寸。七个关键节点，浓缩了大多数商务危机从发生到收尾的完整路径。",
          "值得注意的是，不同节点的舆论期待并不相同：第一时间的沉默会被视为逃避，仓促的切割又会被批评“只爱钱不负责”。因此成熟的处理通常先稳住情绪、再补充事实、最后给出落地方案，把节奏握在自己手里。",
        ],
      },
      {
        heading: "复盘的价值在于建立坐标系",
        paragraphs: [
          "我们不主张对具体当事人做道德审判，而是希望通过这类结构化的节点复盘，帮读者建立对舆论事件的“坐标系”：知道什么时候该等、什么时候该看、什么时候信息仍不完整。当你能判断事件处于哪个阶段，就更能抵抗情绪化传播带来的信息焦虑。",
        ],
      },
    ],
  },
  {
    slug: "shenba-ta-fang-rumor",
    channel: "shenba",
    kind: "复盘",
    title: "“塌房”传闻如何发酵？以一场演唱会变更为例看信息传播链",
    dek: "一条变更通知如何被脑补成一部连续剧？我们把信息传播的每一环都摊开给你看。",
    excerpt:
      "从演唱会延期公告出发，复盘一条中性信息如何在讨论中不断“加码”，最终演变成围绕个人口碑的连环传闻，并梳理信源可靠性的分级。",
    author: "查图员",
    date: "2026-07-30",
    minutes: 8,
    heat: 52100,
    featured: true,
    tags: ["演唱会", "传闻", "信息甄别"],
    sections: [
      {
        heading: "一条中性信息为何会被“加码”",
        paragraphs: [
          "某歌手因故宣布一场演唱会延期，公告措辞简短、未说明具体原因。这本是一则中性的变动信息，却因为“不解释”而留下了解释空间：身体状况、档期冲突、内部变故……每一个猜测都顺势找到了“合理”的依据，信息在转发中不断被添油加醋。",
          "我们把这条信息的传播链拆开看：它经历了“官方公告 → 搬运解读 → 模糊引述 → 二次创作”四个环节，每一次转发都可能丢失原文限定词，最终结论与原始信息之间的偏差被越拉越大。",
        ],
      },
      {
        heading: "给信源做分级，谣言就少了",
        paragraphs: [
          "面对这类传闻，与其急于站队，不如先给信源做一次分级：第一级是当事人与官方的一手声明，第二级是权威媒体的核实报道，第三级是匿名爆料与二手转述。真正影响判断质量的，往往不是信息量的多寡，而是我们是否愿意按可靠程度去排序使用它们。",
          "这也是今日吃瓜坚持只整理公开材料、标注信源层级的原因——我们希望你带走的是分辨方法，而不只是一个被结论喂饱的观点。",
        ],
      },
    ],
  },
  {
    slug: "shenba-pianyue-dangdang",
    channel: "shenba",
    kind: "复盘",
    title: "片约“撞档”风波：从官宣到改期的舆情轨迹",
    dek: "两部剧同时官宣主演，谁先谁后、谁真谁假？一场撞档争议的完整舆情轨迹。",
    excerpt:
      "当一个名字同时出现在两部作品的官宣里，“抢戏”“撞档”“炒热度”的猜测随之而来。我们整理了这类风波的典型轨迹与通常的收尾方式。",
    author: "瓜田主笔",
    date: "2026-06-19",
    minutes: 6,
    heat: 40800,
    tags: ["影视", "档期", "番位"],
    sections: [
      {
        heading: "撞档是怎么发生的",
        paragraphs: [
          "在影视行业里，演员在同一时期接触、洽谈多个项目并不罕见，真正“官宣撞车”往往源于项目方之间的沟通时间差。可当两部作品的宣发物料在同几天密集放出，观众难免用“谁蹭谁”“谁被换”的逻辑去脑补恩怨，番位与档期之争就此登上热榜。",
          "从过往案例看，这类风波的走向通常有三种：其一，其中一方澄清“仅为洽谈，档期冲突未能成行”；其二，双方错峰官宣、以新项目转移视线；其三，发酵为公开声明，明确各自立场。多数情况在项目正式开机后，热度便会自然归于平静。",
        ],
      },
      {
        heading: "让物料回归项目本身",
        paragraphs: [
          "当一部剧的讨论重心从“作品质量”漂移到“演员排位”，某种程度上就是被舆论带着走了。我们更建议把目光放回项目本身：预告质感如何、阵容是否适配、题材是否新鲜。作品才是那根不会被时间冲走的锚。",
        ],
      },
    ],
  },

  // ---------- 光影幕后 ----------
  {
    slug: "yingshi-shuqi-koubei",
    channel: "yingshi",
    kind: "观察",
    title: "暑期档观察：口碑，正在跑赢流量",
    dek: "当观众越来越不愿意为“热闹”买单，一部剧该靠什么留下来？",
    excerpt:
      "从排片结构到社交媒体讨论，2026年暑期档最明显的变化是：口碑评分对票房的牵引力正在超过单纯的话题热度。",
    author: "放映室",
    date: "2026-08-20",
    minutes: 6,
    heat: 33000,
    featured: true,
    tags: ["暑期档", "票房", "口碑"],
    sections: [
      {
        heading: "观众开始用脚投票给内容",
        paragraphs: [
          "回看这个暑期，叫好又叫座的作品有一个共同点：它们都把预算花在了内容本身，而不是把功夫全用在宣发制造话题上。片方数据也显示，开画后的评分走势对周末票房的影响权重，比档期初的话题热度更持久、更稳定。",
          "换句话说，一次性消费的“热闹”正在失灵，能留下来的，是能经得起二刷讨论的剧本、表演与制作。观众的审美升级，倒逼行业把注意力从营销场搬回片场。",
        ],
      },
      {
        heading: "口碑的传导需要时间",
        paragraphs: [
          "值得注意的是，口碑的发酵往往滞后于上映首周。真正依靠口碑走出来的作品，多半经历了“开画普通 → 圈层讨论 → 破圈爆发”的三段式曲线。这也提醒市场：排片不该只给开画热闹的电影机会，也应该给被观众反复安利的作品留出窗口。",
        ],
      },
    ],
  },
  {
    slug: "yingshi-fuzhuangdao",
    channel: "yingshi",
    kind: "观察",
    title: "古装剧服化道翻车之后，靠什么“美学自救”",
    dek: "当考据党挑出满身毛病，剧组还能靠一套完整的美学逻辑翻盘吗？",
    excerpt:
      "一部古装剧的服化道争议，本质上是“考据正确”与“美学自洽”之间的拉扯。看看真正被记住的作品如何化解这道题。",
    author: "幕后人",
    date: "2026-07-12",
    minutes: 6,
    heat: 27100,
    tags: ["古装剧", "服化道", "美学"],
    sections: [
      {
        heading: "考据正确不是唯一标尺",
        paragraphs: [
          "随着观众考据热情的上升，古装剧里每一件配饰、每一道纹样都可能被拿到放大镜下对照史料。翻车案例确实不少，但一个被忽略的事实是：真正封神的古装造型，往往并非百分百还原，而是建立了一套自洽的美学系统——在历史依据之上做有方向的取舍，让整体大于细节之和。",
        ],
      },
      {
        heading: "一致性比单个道具更重要",
        paragraphs: [
          "观众对服化道的不满，很多时候并非源于某一件器物不对，而是整体质感的不统一：主角服制华丽、群演服装却敷衍，武打戏造型考究、文戏却随意。风格体系的崩塌比单点错误更伤观感。那些被夸“审美在线”的剧组，赢在多了一个贯穿始终的设计逻辑。",
        ],
      },
    ],
  },
  {
    slug: "yingshi-xuanchuan-paiwei",
    channel: "yingshi",
    kind: "深扒",
    title: "番位之外的博弈：宣传物料排位背后的行业惯例",
    dek: "官宣海报谁在前谁在后，背后是一套没人写在明面上的行业规则。",
    excerpt:
      "番位不只是名字的先后，它对应着片酬比例、戏份期待与商业背书。我们把影视宣发排位的潜规则摊开，讲清背后的逻辑。",
    author: "放映室",
    date: "2026-06-02",
    minutes: 7,
    heat: 31900,
    tags: ["番位", "宣发", "行业惯例"],
    sections: [
      {
        heading: "排位从来不是随便排的",
        paragraphs: [
          "观众最敏感的海报站位与片头字幕顺序，在行业内有讲究。传统上按资历与戏份排定，而在流量时代，艺人的市场号召力成为重要权重。多数剧组会在合同中写明“排位条款”，避免上线后因排序扯皮。所谓番位之争，本质上是资源与回报分配的一次公开竞价。",
        ],
      },
      {
        heading: "把注意力还给作品",
        paragraphs: [
          "宣发排位是行业规则的一部分，理解它能帮你看懂博弈，但若把整部剧的价值都押在一张海报的顺序上，反而窄化了作品。真正经得起看的主创合作，靠的是角色适配与化学反应，而不是名字谁先谁后。",
        ],
      },
    ],
  },
  {
    slug: "yingshi-zhenchang-luyin",
    channel: "yingshi",
    kind: "深扒",
    title: "幕后声音：录音棚里的“真唱”与“修音”之争",
    dek: "一场演唱会真唱争议，把“现场”与“棚音”的边界重新抛回台前。",
    excerpt:
      "从修音技术到全开麦标准，我们走进录音棚与现场制作的后台，看看“真唱”这件事在技术上到底有多复杂。",
    author: "阿剪",
    date: "2026-05-18",
    minutes: 6,
    heat: 29800,
    tags: ["音乐", "真唱", "演出"],
    sections: [
      {
        heading: "“开麦”不是一个非黑即白的问题",
        paragraphs: [
          "演唱会现场的音源处理远比观众想象复杂：全开麦、半开麦、垫音、现场修音，不同选择对应不同风险与收益。完全“素唱”对体能与临场要求极高，而过度依赖技术又会引发“假唱”质疑。行业目前最大的共识，是希望主办方与艺人坦诚说明现场的真实呈现方式。",
        ],
      },
      {
        heading: "观众要的是诚意，不只是一台完美机器",
        paragraphs: [
          "反复发酵的真唱争议，核心其实不在技术指标，而在“是否诚实”。当演出宣传强调“全开麦”却最终依赖修音时，落差感才会转化为愤怒。技术可以辅助表达，但不该成为掩盖实力的手段——这大概是录音棚里最朴素的一条行业准则。",
        ],
      },
    ],
  },

  // ---------- 娱圈观察 ----------
  {
    slug: "yule-yanchanghui",
    channel: "yule",
    kind: "观察",
    title: "演唱会经济升温：从抢票到二手平台的乱象观察",
    dek: "抢票秒空与高价转售并存，一场演唱会为什么越来越难“好好看”？",
    excerpt:
      "线下演出复苏带来消费热，也放大了票务链条上的顽疾。我们从出票机制、黄牛生态与平台治理三方面做了一次拆解。",
    author: "观察席",
    date: "2026-08-05",
    minutes: 7,
    heat: 45300,
    tags: ["演唱会", "票务", "黄牛"],
    sections: [
      {
        heading: "秒空背后，不只是需求旺盛",
        paragraphs: [
          "当一场演唱会开票数秒即“售罄”，随即在二手平台出现天价转售时，供需失衡之外，往往还有抢票脚本、囤票与退票漏洞等灰色操作在起作用。正规渠道抢不到、黄牛渠道要加价，成了许多乐迷最真实的无奈。",
        ],
      },
      {
        heading: "治理正在从“堵”走向“疏”",
        paragraphs: [
          "近年来主办方与平台也在调整：实名入场、限购与退票规则收紧、演出前后台动态放票，都在压缩投机空间。对普通观众而言，认准官方购票、警惕非官方“代拍”，仍是避开票务风险最有效的两件事。",
        ],
      },
    ],
  },
  {
    slug: "yule-fans-shengtai",
    channel: "yule",
    kind: "观察",
    title: "粉丝生态简史：从应援追星到“反黑”的组织化",
    dek: "今天的粉丝群体如何运转？一套精细得像公司的组织架构，正在改变舆论场的形态。",
    excerpt:
      "打榜、控评、反黑、应援……粉丝生态的组织化程度远超多数人的想象。这篇观察梳理它从“个体追星”到“团队作战”的演化。",
    author: "观察席",
    date: "2026-06-24",
    minutes: 8,
    heat: 38600,
    tags: ["粉丝", "饭圈", "生态"],
    sections: [
      {
        heading: "一套像公司一样的运转逻辑",
        paragraphs: [
          "头部粉丝群体内部通常分工明确：有负责数据打榜的“数据组”、维护口碑的“反黑组”、组织活动的“应援组”，甚至有对接经纪方的“官群管理”。这种组织化在放大传播效率的同时，也让负面信息的扩散更具“动员性”，一旦方向跑偏，极易演变为群体对抗。",
        ],
      },
      {
        heading: "健康的追星，是先成为更好的自己",
        paragraphs: [
          "我们无意妖魔化任何追星行为，喜欢一个人并为之努力本身无可厚非。真正需要警惕的，是把全部自我价值寄托于一个偶像、为维护偶像而丢失独立思考。追星的理想状态，是借由欣赏他人获得向上的能量，而不是在群体情绪里迷失自己。",
        ],
      },
    ],
  },
  {
    slug: "yule-juben-jiedu",
    channel: "yule",
    kind: "观察",
    title: "综艺“剧本感”为何让人又爱又恨",
    dek: "没有剧本会乱，剧本太重会假，综艺如何在“真实”与“好看”之间走钢丝？",
    excerpt:
      "观众一边吐槽综艺套路化，一边又离不开熟悉的流程带来的安全感。剧本感问题的本质，是制作方对“真实”的拿捏。",
    author: "瓜田主笔",
    date: "2026-05-09",
    minutes: 6,
    heat: 25400,
    tags: ["综艺", "剧本", "真人秀"],
    sections: [
      {
        heading: "真人秀的“真”是一种被引导的真实",
        paragraphs: [
          "几乎没有人会天真到相信真人秀毫无编排，但过度生硬的剧本感依然会劝退观众。好的制作团队把脚本藏在机制里：设定任务、制造冲突环境，却把最终的反应留给嘉宾。观众要的其实不是毫无设计的“素人直播”，而是“在合理设计之下仍然真诚”的临场反应。",
        ],
      },
      {
        heading: "套路与反套路的螺旋",
        paragraphs: [
          "综艺行业的创新，常是一场与观众预期的博弈：当“反转”成为标配，观众开始预判反转；当“躺平”成为人设，观众又期待成长线。真正耐看的综艺，往往在结构上大胆、在人物上克制，用真实的人格替代功能化的标签。",
        ],
      },
    ],
  },
  {
    slug: "yule-jiaoji-huashu",
    channel: "yule",
    kind: "观察",
    title: "营业学：艺人互动模板化的台前幕后",
    dek: "同一个表情包、同一套回应话术，明星营业为何越来越像“标准作业”？",
    excerpt:
      "当互动变得可预测，评论区反而开始怀念真实的“翻车”。营业模板化背后，是安全考量和表达自由之间的长期拉锯。",
    author: "阿剪",
    date: "2026-04-16",
    minutes: 6,
    heat: 22100,
    tags: ["营业", "艺人", "互动"],
    sections: [
      {
        heading: "模板化是风险的避风港",
        paragraphs: [
          "在舆论放大镜之下，一次随意的发言都可能被截取成“翻车现场”，于是越来越多艺人与团队选择用经过背书的模板话术与表情包完成互动。这确实规避了风险，却也稀释了真实的个性表达，让“营业”越来越像交作业。",
        ],
      },
      {
        heading: "观众渴望的是不完美的人味",
        paragraphs: [
          "有趣的是，真正打动观众的往往是那些“不够完美”的瞬间：一句措辞笨拙但真心的回应、一次没被设计好的临场发挥。安全与真诚并非不可兼得，关键在于团队是否愿意在可控范围内，把话筒适当交还给艺人自己。",
        ],
      },
    ],
  },

  // ---------- 红馆速递 ----------
  {
    slug: "hongguan-regao-yitian",
    channel: "hongguan",
    kind: "速递",
    title: "今日热搜回顾：三条线索串起的一天",
    dek: "从早上的官宣到深夜的路透，娱乐圈的一天能有多热闹？",
    excerpt:
      "我们把今天的圈内热搜按时间串成三条线索：官宣档、综艺场、演唱会筹备，速览一天的重点动向。",
    author: "值班编",
    date: "2026-08-30",
    minutes: 3,
    heat: 14500,
    tags: ["热搜", "速递"],
    sections: [
      {
        heading: "上午：两则官宣引爆话题",
        paragraphs: [
          "上午时段圈内迎来两则官宣：一部剧集公布开机阵容、一位歌手宣布全国巡演加场。前者延续了近期题材热，后者则再次印证演出市场的升温，相关关键词在中午前后双双冲上热榜。",
        ],
      },
      {
        heading: "下午到深夜：综艺与筹备动向",
        paragraphs: [
          "午后一档户外综艺释出先导预告，嘉宾互动片段被广泛转发；晚间则有品牌官宣新代言人的消息放出，商务与粉丝两端讨论度都不低。整体而言，这一天信息密度高、但大多停留在“正常营业”范畴，暂无需要特别警惕的负面发酵。",
        ],
      },
    ],
  },
  {
    slug: "hongguan-yizhou-dashi",
    channel: "hongguan",
    kind: "速递",
    title: "一周圈子大事记：官宣、改档与声明",
    dek: "把过去七天值得记住的圈内动向，一次性给你复盘清楚。",
    excerpt:
      "这一周娱乐圈有哪些值得留意的节点？我们挑出官宣、改档与声明三类事件，做了精简版的一周大事记。",
    author: "值班编",
    date: "2026-08-16",
    minutes: 4,
    heat: 12800,
    tags: ["周报", "速递"],
    sections: [
      {
        heading: "官宣与改档并存的一周",
        paragraphs: [
          "本周既有新剧开机、综艺定档的好消息，也有数部影片因排期调整而改档。改档原因多为排片协调，尚未出现影响项目推进的负面信号，剧集与影迷只需留意最新的正式公告即可。",
        ],
      },
      {
        heading: "两则声明，两种教科书式回应",
        paragraphs: [
          "值得留意的还有两则团队声明：一则是针对网络不实信息的澄清，措辞克制、点到即止；另一则就此前争议道歉并给出整改动作。前者赢在信息清晰，后者赢在敢于落地，都是可供对比的公关样本。",
        ],
      },
    ],
  },
  {
    slug: "hongguan-jichang-huashu",
    channel: "hongguan",
    kind: "速递",
    title: "机场穿搭内卷：镜头下的“营业”时刻",
    dek: "机场本是最生活化的场景，如今却成了最新的时尚秀场。",
    excerpt:
      "从偶遇到精心安排的“偶遇”，机场照背后的拍摄生态，正把赶路变成一场高强度的形象运营。",
    author: "阿剪",
    date: "2026-07-25",
    minutes: 4,
    heat: 11200,
    tags: ["穿搭", "街拍", "生态"],
    sections: [
      {
        heading: "从真实抓拍到主动营业",
        paragraphs: [
          "早年机场照以粉丝偶遇的抓拍为主，如今越来越多的团队会提前协调、安排机位，艺人则配合造型完成“行走的杂志封面”。真实性在下降，精致度在上升，机场也随之从交通枢纽变成了形象输出的重要场景。",
        ],
      },
      {
        heading: "运营与生活的边界",
        paragraphs: [
          "被安排得明明白白的机场营业，某种程度上是行业高度商品化的缩影。它并无对错，但当“营业感”盖过生活感，观众反而会更珍惜那些偶尔露出的、真实的疲态与松弛。",
        ],
      },
    ],
  },
];

// 首页热榜（按热度取前若干，用于首屏与专题位）
export const hotKeywords: string[] = [
  "选秀剧本感争议",
  "暑期档口碑复苏",
  "演唱会票务乱象",
  "番位排位博弈",
  "机场营业穿搭",
  "危机公关节点",
  "粉丝生态组织化",
  "真唱与修音之争",
];

// 站内 FAQ（同时以 FAQPage 结构化数据输出到页面）
export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "今日吃瓜报道的内容真实吗？",
    a: "今日吃瓜只按公开材料整理内幕消息与内幕真相，所有节点均来自官方公告、公开播出画面、媒体报道等可核验信源。我们对争议事件以时间线复盘呈现，明确标注信源层级，不做主观猜测，也不对当事人做道德审判。",
  },
  {
    q: "为什么你们把“内幕消息”和“内幕真相”放在一起说？",
    a: "因为我们希望你能区分两者：内幕消息是处于传播中的、待核验的信息，内幕真相则需要多方交叉印证后才能接近。我们把零散线索收拢成完整叙事，目的不是替你做结论，而是帮你站在更完整的信息基础上形成自己的判断。",
  },
  {
    q: "深扒档案里的事件，一定都有确切结果吗？",
    a: "不一定。部分事件在公开信息层面仍处于进行时，我们会如实标注“尚无定论”。比起给出一个看似确定的答案，我们更看重过程的透明：时间线到哪一步、哪些信源尚未回应，都尽量讲清楚。",
  },
  {
    q: "我看到的传闻为什么常常前后矛盾？",
    a: "传闻在传播中会被反复“加码”，每次转发都可能丢失原文限定词。应对矛盾最好的办法是先给信源做分级：官方声明与一手证据优先，匿名爆料与二次转述其次，再对照多方说法交叉比对，谣言大多经不起这一步。",
  },
  {
    q: "你们会不会为了流量炒作夸大？",
    a: "不会。今日吃瓜的核心方法是用时间线把复杂事件拆解清楚，而非用标题制造刺激。我们宁愿信息冷静、克制，也不愿为了一次点击牺牲读者对事件的整体判断。",
  },
  {
    q: "如何向今日吃瓜投稿或提供线索？",
    a: "如果你掌握与圈内事件相关的公开线索或希望申请内容合作，欢迎通过页面底部或联系我们页面的邮箱与我们取得联系，我们会认真对待每一份来信。",
  },
];

// 站内方法论（“我们如何甄别内幕”四原则）
export interface Principle {
  n: string;
  title: string;
  text: string;
}

export const principles: Principle[] = [
  {
    n: "01",
    title: "只看公开材料",
    text: "官方公告、公开画面、可检索报道是我们的信源底线，避免未经证实的“小道消息”直接入库。",
  },
  {
    n: "02",
    title: "给信源分级",
    text: "一手声明优先于二手转述，标注每一条信息所处层级，方便你自行掂量它的分量。",
  },
  {
    n: "03",
    title: "串联时间线",
    text: "把零散线索按时间串起来，交叉比对关键节点，让前后因果自己浮现，而不是凭直觉拼凑。",
  },
  {
    n: "04",
    title: "不下预设结论",
    text: "整理内幕真相不等于制造定论，未定论的事件我们如实标注，判断权始终交还给你。",
  },
];

export const industryStats: { value: string; label: string }[] = [
  { value: "1200+", label: "公开线索归档" },
  { value: "40+", label: "时间线复盘专题" },
  { value: "90%", label: "内容依托一手信源" },
  { value: "7×12", label: "编辑部值守时段" },
];